import React from 'react'
import { Box, Grid, IconButton } from '@mui/material'
import LinkedInIcon from '@mui/icons-material/LinkedIn'
import GitHubIcon from '@mui/icons-material/GitHub'
import { useConfig } from '../hooks/useConfig'

const Footer: React.FC = () => {
    const { config } = useConfig()

    if (!config) {
        return null
    }

    return (
        <Box
            sx={{
                backgroundColor: 'divider',
                color: 'text.primary',
                padding: '2rem',
                width: '100%',
                textAlign: 'left',
            }}
        >
            <Grid
                container
                spacing={2}
                alignItems="center"
                justifyContent="left"
            >
                <Grid item xs="auto">
                    {/* /* Contact Info */}
                    <Box sx={{ whiteSpace: 'nowrap' }}>
                        <p>{config.footer.name}</p>
                        <a href={`mailto:${config.footer.email}`}>
                            {config.footer.email}
                        </a>
                    </Box>
                </Grid>
                <Grid item xs="auto">
                    {/* Social Icons */}
                    <Box>
                        <IconButton href={config.footer.linkedin.href}>
                            <LinkedInIcon />
                        </IconButton>
                        <IconButton href={config.footer.github.href}>
                            <GitHubIcon />
                        </IconButton>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    )
}

export default Footer
